import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import tplHelpers from "../../../helpers/tpl";
import ThirdPartyLogisticsCreateShipmentForm from './ThirdPartyLogisticsCreateShipmentForm';
import ThirdPartyLogisticsCreateShipmentTable from './ThirdPartyLogisticsCreateShipmentTable';

function ThirdPartyLogisticsCreateShipment(props) {

    const [warehouse, setWarehouse] = useState("");
    const [orderNbr, setOrderNbr] = useState("");
    const [trOrder, setTrOrder] = useState("");

    const warehouse_options = [
        {value: 'PA', name: 'Pennsylvania'},
        {value: 'TX', name: 'Texas'},
    ];

    useEffect(() => {
        setTrOrder("");
    }, [orderNbr, warehouse]);

    const getAcumaticaRealTimeBuilds = async() => {
        props.setLoading(true);
        try {
            const formattedAcuNumber = formatAcuOrderNum(orderNbr);
            const res = await tplHelpers.getAcumaticaRealTimeBuilds(formattedAcuNumber, warehouse, props.company, props.token);
            console.log('res', res)
            if (res.status === 'Order Not Found!') {
                props.toast.error(`Could not find transfer order ${orderNbr}!`);
            } else if (res.status !== 'Open' && res.status !== 'Shipping') {
                props.toast.error(`The status of ${orderNbr} is ${res.status}.`);
            } else {
                setTrOrder(res.orders[0]);
            };
           
        } catch (err) {
            console.log('getAcumaticaRealTimeBuilds Error: ', err);
        } finally {
            props.setLoading(false);
        };
    };

    const formatAcuOrderNum = (acuOrderNum) => {
        while (acuOrderNum.length < 7) {
            acuOrderNum = '0' + acuOrderNum;
        };
        return acuOrderNum;
    };

    const submitBuilds = async () => {
        // props.setLoading(true);
        // try {
        //     if (warehouse === 10) {
        //         const res = await tplHelpers.sendGeodisAsn(trOrder, props.warehouse, props.token);
        //         if (res.success) {
        //             props.toast.success("ASN Sent");
        //             setTrOrder("");
        //             setOrderNbr("");
        //             setWarehouse("");
        //         } else {
        //             props.toast.error("Failed to send ASN");
        //         }
        //     } else {
        //         props.toast.error('Cannot send ASN.');
        //     }
        // } catch (err) {
        //     console.log(err);
        // } finally {
        //     props.setLoading(false);
        // }
    };

    return (
        <Box display = "flex" flexDirection = "column" className = {props.isMobile ? "mobile-top" : "desktop-top"}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
                <h1>Create Shipment</h1> 
                <p>Enter the Transfer Order Number that has been built.</p>
                <ThirdPartyLogisticsCreateShipmentForm
                    warehouse_options = {warehouse_options}
                    warehouse = {warehouse}
                    setWarehouse = {setWarehouse}
                    orderNbr = {orderNbr}
                    setOrderNbr = {setOrderNbr}
                    getAcumaticaRealTimeBuilds = {getAcumaticaRealTimeBuilds}
                 />
                { trOrder ?
                    <Box display = "flex" flexWrap = "wrap" gap = {2} sx = {{ mt: '20px' }}>
                        <Box>
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Transfer Order Number:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.OrderNbr}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box >
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Order Date:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.Date}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box >
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Total Ordered Quantity:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.Total}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box >
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Current Total on Shipments:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.CurrentTotalOnShipments}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box >
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom>
                                        Shipment Number:
                                    </Typography>
                                    <Typography 
                                        sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                    >
                                        {trOrder.ShipmentNbr || 'N/A'}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <ThirdPartyLogisticsCreateShipmentTable
                            loading = {props.isLoading}
                            items = {trOrder.Items}
                            submitBuilds = {submitBuilds}
                            warehouse_options = {warehouse_options}
                            warehouse = {warehouse}
                        />
                    </Box>
                : null }
            </Box>
        </Box>
    )
}

export default ThirdPartyLogisticsCreateShipment;